import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import * as Yup from "yup";
import { Button } from "primereact/button";
import { RESET_ERROR } from "../../store/Types/AuthTypes";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

import {
  addProduct,
  getArticleNumForProduct,
  getOptionValues,
  getProducts,
  getVarientOption,
  getspecificProduct,
  getspecificVarientsByProduct,
  getAllVarients,
  updateProduct,
} from "../../store/AsyncMethods/ProductMethod";
import {
  getCategory,
  getSubCategory,
} from "../../store/AsyncMethods/CategoryMethod";
import { RESET_SPECIFIC_PRODUCT } from "../../store/Types/ProductTypes";
import AddSalesForm from "./AddSalesForm";
// import { getSales } from "../../store/AsyncMethods/SalesMethod";
import { getCustomers } from "../../store/AsyncMethods/CustomerMethod";
import AddSalesProductForm from "./AddSalesProductForm";
import AddSalesProductTable from "./AddSalesProductTable";
import SalesCalculation from "./SalesCalculation";
import {
  addSale,
  getSales,
  getspecificSale,
  updateSales,
} from "../../store/AsyncMethods/SalesMethod";
import { RESET_SPECIFIC_SALES } from "../../store/Types/SalesTypes";
import QRCode from "react-qr-code";
import moment from "moment";
import { getVat } from "../../store/AsyncMethods/SetupMethod";
import AddSalesPayment from "./AddSalesPayment";
import { getPaymentMethod } from "../../store/AsyncMethods/PaymentMethod";

export default function AddSales() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [isFullPayment, setIsFullPayment] = useState(false);
  const [postDisabled, setPostDisabled] = useState(false);
  const { saleId } = useParams();
  const { allVat } = useSelector((state) => state.VatReducer);
  const { subCategories } = useSelector((state) => state.CategoryReducer);

  // const [showProductForm, setShowProductForm] = useState(true);
  const timeZone = "Asia/Karachi"; // Convert to New York time zone

  const { error, user } = useSelector((state) => state.AuthReducer);
  const { specificVarients } = useSelector((state) => state.ProductReducer);
  const { enableCurrency } = useSelector((state) => state.CurrencyReducer);
  const { specificSale } = useSelector((state) => state.SalesReducer);
  const [isDisabled, setIsDisabled] = useState(false);
  const [filterSubCategories, setFilterSubCategories] = useState([]);
  const [dates, setDates] = useState({
    date: new Date(),
    due_date: new Date(),
    invoice_date: new Date(),
  });
  const [validateVarient, setValidateVarient] = useState(true);
  const [isRefund, setIsRefund] = useState(false);

  const [currentProductQuantity, setCurrentProductQuantity] = useState(0);
  const [slectedProductQuantity, setSelectedProductQuantity] = useState(0);
  const { specificCustomer } = useSelector((state) => state.CustomersReducer);

  // const varientOptionsValidation = varientOptions.reduce((acc, option) => {
  //   acc[option.label] = Yup.object().required(`${option.label} is required`);
  //   return acc;
  // }, {});

  const [editingProduct, setEditingProduct] = useState(null);

  const editProduct = (product) => {
    debugger
    setEditingProduct(product);
    // setShowProductForm(true);
  };

  useEffect(() => {
    if (specificSale) {
      console.log(`Specific sale data: ${specificSale}`);
      dates.date = new Date(specificSale.date);
      dates.due_date = new Date(specificSale.due_date);
      dates.invoice_date = new Date(specificSale.invoice_date);

      formik.setValues({
        name: specificSale.customer_name || "Customer",
        customer: specificSale.customer_id || 0,
        saleStatus: specificSale.status || "invoice",
        phone: specificSale.customer_phone || "03",
        totalPurchase: specificSale.total_purchase || 0,
        status: specificSale.is_active === 1 ? true : false,
        totalSales: specificSale.total_sales || 0,

        totalDiscount: specificSale.total_discount || 0,
        vatPer: specificSale.vat_per || 0,
        vatAmount: specificSale.vat_amount || 0,
        currencyId: specificSale.currency_id || 1,
        vatNumber: specificSale.vat_number || "",
        totalAmount: specificSale.total_amount || 0,
        userId: user.id,
        posted: specificSale.is_posted || 0,
        products: specificSale.products || [],
        paymentTypeId: specificSale.payment_type_id || 2,
        cashier: specificSale.cashier || "",
        amountReceived: specificSale.amount_received || 0,
        remainAmount: specificSale.remain_amount || 0,
        isDiscount: specificSale.is_discount > 0 ? true : false || false,
        date: dates.date || "",
        due_date: dates.due_date || "",
        invoice_date: dates.invoice_date || "",
        product: {
          categoryId:0,
          subCategoryId:0,
          unit_price: null,
          misc_charges: null,
          product: "",
          varient: "",
          discount: null,
          quantity: null,
          total: 0,
          discount_value: 0 ,
          is_discount_percentage: true,
        },
        
      });
      if (specificSale.is_posted == 1) {
        setIsDisabled(true);
      }
    }
  }, [specificSale]);

  useEffect(() => {
    dispatch(getPaymentMethod());
  }, []);
  useEffect(() => {
    formik.values.date = dates.date;
    formik.values.due_date = dates.due_date;
    formik.values.invoice_date = dates.invoice_date;
  }, [dates]);
  
  
  const formik = useFormik({
    initialValues: {
      name: "Customer",
      phone: "03",
      customer: "",
      vatNumber: "",
      status: true,
      totalmiscCharges:null,
      saleStatus: "invoice",
      products: [],
      userId: user.id,
      currencyId: enableCurrency?.currency_id || 1,
      totalPurchase: 0,
      totalSales: 0,
      totalDiscount: 0,
      vatPer: allVat.find((vat) => vat.type === "sales")?.percentage || 0,
      vatAmount: 0,
      totalAmount: 0,
      posted: 0,
      paymentTypeId: 1,
      cashier: "",
      amountReceived: 0,
      remainAmount: 0,
      isDiscount: false,
      product: {
        unit_price: null,
        product: null,
        varient: null,
        discount: null,
        quantity: null,
        total: null,
        categoryId:0,
        subCategoryId: 0,
        discount_value: 0,
        is_discount_percentage: true,
        date: dates.date,
        due_date: dates.due_date,
        invoice_date: dates.invoice_date,
        misc_charges:null,
      }
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Customer Name Required"),
      phone: Yup.string().required("Customer Phone Number Required"),
      customer: Yup.number().required("Customer Required"),
      date: Yup.string().required("Date Required"),
      amountReceived: Yup.number().required("Amount Received Required"),
      paymentTypeId: Yup.number().required("Payment Type Required"),
      due_date: Yup.string().required("Due Date Required"),
      invoice_date: Yup.string().required("Invoice Date Required"),
      // vatNumber: Yup.string()
      //   .required("VAT Number Required")
      //   .matches(
      //     /^3\d{13}3$/,
      //     'VAT Number must be 15 digits long and start and end with "3"'
      //   ),
      saleStatus: Yup.string().required("Sale Status Required"),
      status: Yup.boolean().required("Status Required"),
      product: validateVarient
        ? Yup.object().shape({
            // product: Yup.number().required("Product Required"),
            // varient: Yup.number(),
            // purchasePrice: Yup.number().required("Purchase Price is required"),
            // salePrice: Yup.number().required("Sale Price is required"),
            // discount: Yup.number().required("Discount is required"),
            // quantity: Yup.number().required("Quantity is required"),
            // .positive("Quantity should be greater than 0")
            // .max(
            //   currentProductQuantity,
            //   "Quantity should be less than or equal to current product quantity."
            // ),
            total: Yup.number().required("Total is required"),
            discount_value: Yup.number().required("Discount is required"),
            is_discount_percentage: Yup.boolean(),
          })
        : Yup.object(),
    }),

    onSubmit: async (data) => {
      debugger
      // console.log(data);
      // delete data.product
      data.product = data.products
      // delete data.products
      // console.log(data)
      //const incrementedDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1);
      //data.date=moment.tz(data.date, 'YYYY-MM-DDTHH:mm:ssZ', timeZone);
      if (specificSale) {
        dispatch(updateSales(data, saleId)).then((success) => {
          if (success) {
            formik.resetForm();
            dispatch(getSales());
            if (formik.values.posted === 1) {
              console.log("success messages",success);
              console.log("value",formik.values.id)
              // dispatch({ type: RESET_SPECIFIC_SALES });
              navigate("/invoice-sales/" + specificSale.id);
            } else {
              navigate(user?.role_id == 1 ? "/sales" : "/sales-sales");
            }
          }
        });
      } else {
        dispatch(addSale(data)).then((success) => {
          if (success) {
            formik.resetForm();
            dispatch(getSales());
            if (formik.values.posted === 1) {
              navigate("/invoice-sales/" + success?.insertSaleId);
            } else {
              navigate(user?.role_id == 1 ? "/sales" : "/sales-sales");
            }
            // navigate(
            //   user?.role_id == 1
            //     ? "/invoice-sales/" + success.insertSaleId
            //     : "/invoice-sales-sales/" + success.insertSaleId
            // );
          }
        });
      }
    },
  });

  useEffect(() => {
    if (formik.values.product?.category) {
      const filter = subCategories.filter(
        (item) => item.category_id === formik.values.product?.category
      );

      if (filter) {
        setFilterSubCategories(filter);
      }
    }
  }, [formik.values.product?.category]);

  useEffect(() => {
    if (formik.values.saleStatus === "refund") {
      // Convert totalSales, totalDiscount, and totalAmount to negative
      formik.setValues({
        ...formik.values,
        totalSales: -formik.values.totalSales,
        totalDiscount: -formik.values.totalDiscount,
        totalAmount: -formik.values.totalAmount,
      });
    } else {
      // Convert totalSales, totalDiscount, and totalAmount to positive
      formik.setValues({
        ...formik.values,
        totalSales: Math.abs(formik.values.totalSales),
        totalDiscount: Math.abs(formik.values.totalDiscount),
        totalAmount: Math.abs(formik.values.totalAmount),
      });
    }
  }, [formik.values.saleStatus]);
  useEffect(() => {
    formik.setFieldValue(
      "remainAmount",
      formik.values.totalAmount - formik.values.amountReceived
    );
  }, [formik.values.totalAmount, formik.values.amountReceived]);

  useEffect(() => {
    dispatch(getPaymentMethod());
  }, []);

  const removeProduct = (productId) => {
    formik.setValues((prevValues) => {
      const updatedProduct = prevValues.products.filter(
        (product) => product.id !== productId
      );
      return { ...prevValues, products: updatedProduct };
    });
  };

  // useEffect(() => {
  //   if (formik?.values?.samePrice) {
  //     formik.setValues({
  //       ...formik.values,
  //       varient: {
  //         ...formik.values.varient,
  //         price: formik?.values?.price,
  //       },
  //     });
  //   } else {
  //     formik.setValues({
  //       ...formik.values,
  //       price: 0,
  //     });
  //   }
  // }, [formik?.values?.samePrice, formik?.values?.price]);

  // useEffect(() => {
  //   if (varientOptions.length > 0) {
  //     varientOptions.map((option) => {
  //       formik.initialValues.varient = {
  //         ...formik.initialValues.varient,
  //         [option.label]: "",
  //       };
  //     });
  //   }
  // }, [varientOptions]);

  useEffect(() => {
    if (formik.values.product?.product) {
      dispatch(getspecificVarientsByProduct(formik.values.product?.product));
    }
  }, [formik.values.product?.product]);

  useEffect(() => {
    if (error) {
      toast.error(error);
      dispatch({ type: RESET_ERROR });
    }
  }, [error]);

  useEffect(() => {
    if (user) {
      dispatch(getCustomers());
      dispatch(getProducts());
      // dispatch(getAllVarients());
      dispatch(getCategory());
      dispatch(getSubCategory());
    }
  }, []);
  useEffect(() => {
    if (allVat) {
      formik.setFieldValue(
        "vatPer",
        allVat.find((vat) => vat.type === "sales")?.percentage || 0
      );
    }
  }, [allVat]);
  useEffect(() => {
    if (enableCurrency) {
      formik.setFieldValue("currencyId", enableCurrency?.currency_id);
    }
  }, [enableCurrency]);

  useEffect(() => {
    if (saleId) {
      dispatch(getspecificSale(saleId));
      setValidateVarient(false);
      // setShowProductForm(false);
    }
  }, []);

  useEffect(() => {
    dispatch({ type: RESET_SPECIFIC_SALES });
    formik.resetForm();
  }, [location.pathname]);

  useEffect(() => {
    if (formik.values.product?.sub_category && specificVarients.length > 0) {
      const varient = subCategories.find(
        (varient) => varient.id === formik.values.product?.sub_category
      );

      if (varient) {
        formik.setFieldValue("product.purchasePrice", varient.price || "");
        setCurrentProductQuantity(varient.quantity);
      } else {
        setCurrentProductQuantity(0);
      }
    } else {
      setCurrentProductQuantity(0);
    }
  }, [formik.values.products]);

  useEffect(() => {

    if (formik.values.product?.unit_price && formik.values.product?.quantity) {
      formik.setFieldValue("product.total",(formik.values.product?.unit_price * formik.values.product?.quantity) + formik.values.product?.misc_charges - formik.values.product?.discount || 0);
    }
  }, [
    formik.values.product?.unit_price,
    formik.values.product?.quantity,
    formik.values.product?.discount,
    formik.values.product?.misc_charges,
  ]);

  // Prevent form submission on Enter key press
  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
      }
    };

    document.addEventListener("keypress", handleKeyPress);
    return () => {
      document.removeEventListener("keypress", handleKeyPress);
    };
  }, []);

  useEffect(() => {
    if (
      formik?.values?.product?.product &&
      formik?.values?.products?.length > 0
    ) {
      const pro = formik?.values?.products.find(
        (pro) => pro.product === formik?.values?.product?.product
      );
      if (pro) {
        setCurrentProductQuantity(currentProductQuantity - pro.quantity);
      }
    }
  }, [slectedProductQuantity]);

  useEffect(() => {
    console.log("Vendor Debit Allowed:", specificCustomer?.debit_allowed);
    if (specificCustomer?.debit_allowed == 1) {
      setIsFullPayment(false);
      setPostDisabled(true);
    } else {
      setIsFullPayment(true);
      setPostDisabled(false);
    }
  }, [specificCustomer?.debit_allowed]);

  useEffect(() => {
    if (postDisabled) {
      const isPaymentComplete =
        Math.abs(formik.values.amountReceived - formik.values.totalAmount) <
        0.01;
      setIsFullPayment(isPaymentComplete);
    }
  }, [formik.values.amountReceived, formik.values.totalAmount]);

  return (
    <div className="mx-4">
      {/* <div>
        <Button
          label="Back"
          icon="pi pi-arrow-left"
          className="p-black-btn"
          onClick={() => {
            formik.resetForm();
            dispatch({ type: RESET_SPECIFIC_SALES });
            navigate(-1);
          }}
        />
      </div> */}
      <form onSubmit={formik.handleSubmit}>
        <AddSalesForm
          formik={formik}
          isRefund={isRefund}
          setIsRefund={setIsRefund}
          isDisabled={isDisabled}
        />

        <div>
          <AddSalesProductForm
            formik={formik}
            filterSubCategories={filterSubCategories}
            // showProductForm={showProductForm}
            // setShowProductForm={setShowProductForm}
            currentProductQuantity={currentProductQuantity}
            setCurrentProductQuantity={setCurrentProductQuantity}
            validateVarient={validateVarient}
            setValidateVarient={setValidateVarient}
            editingProduct={editingProduct}
            disabled={isDisabled}
            setEditingProduct={setEditingProduct}
            setSelectedProductQuantity={setSelectedProductQuantity}
            customerID={formik.values.customer}
          />
        </div>

        <div className="my-3">
          <AddSalesProductTable
            products={formik.values.products}
            removeProduct={removeProduct}
            editProduct={editProduct}
            isDisabled={isDisabled}
          />
        </div>
        <AddSalesPayment formik={formik} isDisabled={isDisabled} />
        {formik.values.products.length > 0 ? (
          <div className="my-3">
            <div className="flex justify-between">
              <div className=""></div>
              <SalesCalculation formik={formik} />
            </div>
          </div>
        ) : null}

        <div className="mt-16">
          <div className="flex justify-end gap-4">
            {!isDisabled ? (
              <>
                {" "}
                <Button
                  label={t("cancel")}
                  icon="pi pi-times"
                  className="p-red-btn"
                  type="button"
                  // disabled={showProductForm}
                  onClick={() => {
                    dispatch({ type: RESET_SPECIFIC_PRODUCT });
                    formik.resetForm();
                    setIsRefund(false);
                  }}
                />

                <Button
                  label={specificSale ? t("update") : t("submit")}
                  icon="pi pi-check"
                  className="p-secondary-btn"
                  type="submit"
                />{" "}
                <Button
                  label={t("post")}
                  icon="pi pi-check"
                  className="p-primary-btn"
                  type="submit"
                  disabled={
                    !isFullPayment || formik?.values?.products?.length === 0
                  }
                  onClick={() => {
                    formik.values.posted = 1;
                  }}
                />
              </>
            ) : (
              <Button
                label={t("go_back")}
                icon="pi pi-chevron-left"
                severity="secondary"
                type="submit"
                onClick={() => {
                  navigate("/sales");
                }}
              />
            )}
          </div>
        </div>
      </form>
    </div>
  );
}
